import {
  Card,
  Col,
  Form,
  Input,
  Row,
  Button,
  message,
  Select,
  notification,
  Spin,
  List,
  Avatar,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { GET, POST, PUT } from "../../utils/apicalls";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const TaskIndex: React.FC = () => {
  const [UsersData, setUsersData] = useState<any>({});
  const [loadingTask, setLoadingTask] = useState<boolean>(false);
  const [loadingComments, setLoadingComments] = useState<boolean>(false);
  const [comments, setComments] = useState<any[]>([]);

  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const [Meta, setMeta] = useState<any>({});
  const { id } = useParams();
  const [taskForm] = Form.useForm();
  const [commentForm] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      getTaskData();
      getAllComments();
    }
  }, [id]);

  const getTaskData = async () => {
    setLoadingTask(true);
    try {
      const api = `${API.TASK_ONE}${id}`;
      const response: any = await GET(api, {});
      setUsersData(response?.data || {});
      taskForm.setFieldsValue(response?.data || {});
    } catch (error: any) {
      console.error("Error fetching task data:", error.message);
      message.error("Failed to fetch task data. Please try again.");
    } finally {
      setLoadingTask(false);
    }
  };

  const onSave = async (values: any) => {
    setLoadingTask(true);
    try {
      const obj = {
        descriptions: String(values.descriptions),
        status: values.status,
        hourss: Number(values.hourss || 0),
        minituess: Number(values.minituess || 0),
      };
      const api = `${API.UPDATE_TASK}${id}`;
      const response: any = await PUT(api, obj);

      if (response) {
        notification.success({
          message: "Task updated successfully",
        });
        navigate(-1);
        window.location.reload();
      } else {
        notification.error({
          message: "Failed to update the task",
        });
      }
    } catch (error: any) {
      console.error("Error saving task:", error.message);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setLoadingTask(false);
    }
  };

  const getAllComments = async () => {
    setLoadingComments(true);
    try {
      const obj = {
        query: "string",
        page: 1,
        take: 50,
        taskid: Number(id),
      };
      const url = API.GET_ALL_COMMENTS;
      const response: any = await POST(url, obj);
      setComments(response?.data || []);
      setMeta(response?.meta || {});
    } catch (error: any) {
      console.error("Error fetching comments:", error.message);
      message.error("Failed to fetch comments. Please try again.");
    } finally {
      setLoadingComments(false);
    }
  };

  const handleSubmit = async (values: any) => {
    setLoadingComments(true);
    try {
      const currentDate = moment().format("YYYY-MM-DD");
      const obj = {
        employeeId: user.id,
        commentId: values.commentId,
        commets: values.commets,
        date: currentDate,
        amount: values.amount,
        projectId: Number(UsersData.Projectid),
        clientId: Number(UsersData.clientid),
        taskid: Number(UsersData.id),
        type: values.type,
      };
      const api = API.CREATE_COMMENTS;
      const response: any = await POST(api, obj);

      if (response) {
        notification.success({
          message: "Comment added successfully",
        });
        commentForm.resetFields();
        getAllComments();
      } else {
        notification.error({
          message: "Failed to add comment",
        });
      }
    } catch (error: any) {
      console.error("Error submitting comment:", error.message);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setLoadingComments(false);
    }
  };

  return (
    <Spin spinning={loadingTask}>
      <div>
        <Card
          style={{ padding: "16px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
        >
          <Form form={taskForm} onFinish={onSave} layout="vertical">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={6}>
                <h4>Task Name</h4>
                <p>{UsersData?.TaskName || "No task name available."}</p>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <h4>Description</h4>
                <p>{UsersData?.descriptions || "No description available."}</p>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <h4>Start Date</h4>
                <p>
                  {UsersData?.startDates
                    ? moment(UsersData.startDates).format("YYYY-MM-DD")
                    : "Not available"}
                </p>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <h4>End Date</h4>
                <p
                  style={{
                    color:
                      UsersData?.endDates &&
                        moment(UsersData.endDates).isBefore(moment(), "day")
                        ? "red"
                        : "inherit",
                  }}
                >
                  {UsersData?.endDates
                    ? moment(UsersData.endDates).format("YYYY-MM-DD")
                    : "Not available"}
                </p>
              </Col>
              <Col xs={24}>
                <Form.Item name="descriptions" label="Descriptions">
                  <Input.TextArea placeholder="Enter descriptions" allowClear />
                </Form.Item>
                <Form.Item name="hourss" label="Hours">
                  <Input type="number" placeholder="Enter hours" allowClear />
                </Form.Item>
                <Form.Item name="minituess" label="Minutes">
                  <Input type="number" placeholder="Enter minutes" allowClear />
                </Form.Item>
                <Form.Item name="status" label="Status">
                  <Select placeholder="Select Status">
                    <Select.Option value="pending">Pending</Select.Option>
                    <Select.Option value="inprogress">
                      In-progress
                    </Select.Option>
                    <Select.Option value="completed">Completed</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Save Task
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>

        {/* Comments Section */}
        <Card title="Comments">
          <Spin spinning={loadingComments}>
            <List
              dataSource={comments}
              renderItem={(comment) => (
                <List.Item>
                  <Avatar>
                    {comment?.empid
                      ? comment?.empid?.fullName
                      : comment?.client?.companyName?.charAt(0) || "U"}
                  </Avatar>
                  <List.Item.Meta
                    title={
                      comment?.empid
                        ? comment?.empid?.fullName
                        : comment?.client?.companyName || "Anonymous"
                    }
                    description={comment?.commets || "No comment available"}
                  />
                </List.Item>
              )}
            />
          </Spin>
          <Form form={commentForm} onFinish={handleSubmit} layout="vertical">
            <Form.Item name="commets" label="Add Comment">
              <Input.TextArea placeholder="Enter your comment" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Submit Comment
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </Spin>
  );
};

export default TaskIndex;
